<template>
  <div class="py-5 container-fluid">
    <div id="topinfo">
      <div class="row mt-4 justify-content-center">
        <div class="col-12">
          <div class="mx-auto col-xl-8 col-lg-9 col-md-10 d-flex mb-2 flex-column card card-body blur shadow-blur">
            <div class="card-header mb-0 text-center">
              <h3 class="font-weight-bolder text-success text-gradient">coatingAI FineTune</h3>
              <h5 class="mb-0">
                for Line <i>{{ line.name }}</i>
              </h5>
            </div>
          </div>
          <div
            v-if="guns_equalization_history.length > 0"
            class="mx-auto col-xl-8 col-lg-9 col-md-10 d-flex mb-2 flex-column card card-body blur shadow-blur"
          >
            <div class="accordion">
              <div class="accordion-item mb-0">
                <h5 class="m-3">
                  <button
                    class="accordion-button collapsed mb-0 p-2"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseParams"
                    aria-expanded="false"
                    aria-controls="panelsStayOpen-collapseParams"
                    style="padding: 0"
                  >
                    <p
                      class="font-weight-bolder mt-1 mb-0"
                      style="font-weight: 700 !important; font-size: 1.05rem; vertical-align: middle"
                    >
                      Guns Equalization History
                      <i
                        class="fa fa-chevron-down"
                        aria-hidden="true"
                      ></i>
                      <i
                        class="fa fa-chevron-up"
                        aria-hidden="true"
                      ></i>
                    </p>
                  </button>
                </h5>
                <div
                  id="panelsStayOpen-collapseParams"
                  class="accordion-collapse collapse"
                  aria-labelledby="panelsStayOpen-headingOne"
                >
                  <div class="accordion-body mt-0 pt-0">
                    <div
                      v-if="guns_equalization_history.length > 0"
                      style="overflow-x: auto"
                    >
                      <div class="card-body py-0">
                        <table class="table table-borderless table-sm mb-0">
                          <tbody style="display: flex; flex-direction: column; gap: 7px">
                            <tr
                              v-for="(guns_equalization, index) in guns_equalization_history"
                              :key="index"
                              class="previous-guns-equalization-row mb-1"
                              @click="routeToGunsEqualizationHistoryItem(guns_equalization.id)"
                            >
                              <td
                                class="text-bold text-center align-middle"
                                style="width: 90px"
                              >
                                Created:
                              </td>
                              <td
                                class="text-secondary text-italic text-center align-middle"
                                style="width: 120px"
                              >
                                <span>{{ guns_equalization.created_at }}</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mx-auto col-xl-8 col-lg-9 col-md-10 d-flex flex-column card card-body blur shadow-blur">
            <div class="card-header row">
              <div class="mt-3">
                <h4 class="text-center mt-1 ms-4">Guns Equalization</h4>
                <div class="justify-content-left mt-4 ms-4 mb-4">
                  <hr class="horizontal dark" />
                </div>
                <div
                  class="card-body"
                  style="padding-top: 0.2rem"
                >
                  <div class="row mb-4">
                    <h5 class="mt-2">Line Layout</h5>
                    <div class="d-flex justify-content-center">
                      <canvas
                        id="lineLayoutCanvas"
                        class="col-12 mt-0 mb-4"
                        width="700"
                        height="300"
                        :style="`max-width: 1280px; ${line.id !== null ? '' : 'display: none;'}`"
                      >
                      </canvas>
                    </div>
                  </div>
                  <div class="row mb-4">
                    <h5>Powder Amount Parameters</h5>
                    <div class="row">
                      <div class="col-4">
                        <label> Minimum Powder Amount </label>
                      </div>
                      <div class="col-4">
                        <label> Maximum Powder Amount </label>
                      </div>
                      <div class="col-4">
                        <label> Time Interval [s]</label>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-4">&nbsp; {{ min_powder_amount_setting }}</div>
                      <div class="col-4">&nbsp; {{ max_powder_amount_setting }}</div>
                      <div class="col-4">&nbsp; {{ time_interval }} s</div>
                    </div>
                  </div>
                  <div class="d-flex justify-content-between align-items-center mb-3">
                    <h5 class="text-start mb-2">Powder Output Measurements</h5>
                  </div>
                  <div style="overflow-x: auto">
                    <div class="table-responsive">
                      <table
                        class="table table-sm text-start"
                        style="border-width: 0 !important"
                      >
                        <thead>
                          <tr>
                            <th>Gun Name</th>
                            <th>Empty bag weight</th>
                            <th
                              v-for="index in maxPairs"
                              :key="'header-' + index"
                            >
                              Setting {{ index }} Weight {{ index }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(gun, gunIndex) in powderoutput_measurements"
                            :key="gunIndex"
                          >
                            <td class="text-center">
                              <div>
                                <p>{{ gunNamesExist(line.gun_names) ? line.gun_names[gunIndex] : gunIndex + 1 }}</p>
                              </div>
                            </td>
                            <td>
                              <div v-if="editablePowderOutputMeasurements">
                                <input
                                  v-model.lazy="gun.empty_bag_weight"
                                  type="number"
                                  class="form-control form-control-sm"
                                  min="0"
                                  :placeholder="`Bag weight [${$store.state.units_system[$store.state.user_data.unit_system].grams}] `"
                                  style="max-width: 190px"
                                  @keydown="numericPositiveOnly"
                                  @change="
                                    updated_powder_output_measurements = true;
                                    is_calculation_completed = false;
                                    powderoutput_measurements = autoFillInputColumn(
                                      powderoutput_measurements,
                                      gunIndex,
                                      'empty_bag_weight',
                                    );
                                    saveFormProgress();
                                  "
                                />
                              </div>
                              <div v-else>
                                {{ gun.empty_bag_weight }}
                              </div>
                            </td>
                            <td
                              v-for="index in maxPairs"
                              :key="'pair-' + gunIndex + '-' + index"
                            >
                              <div
                                v-if="gun.gun_measurements[index - 1]"
                                class="d-flex"
                              >
                                <div style="width: 70px">
                                  {{ gun.gun_measurements[index - 1].setting }}
                                </div>
                                <div v-if="editablePowderOutputMeasurements">
                                  <input
                                    v-model="gun.gun_measurements[index - 1].weight"
                                    type="number"
                                    class="form-control form-control-sm me-2"
                                    placeholder="Weight"
                                    min="0"
                                    style="width: 90px"
                                    :disabled="!editablePowderOutputMeasurements"
                                    @keydown="numericPositiveOnly"
                                    @blur="PowderAmountWeightCheck($event.target.value, gunIndex)"
                                    @change="
                                      updated_powder_output_measurements = true;
                                      is_calculation_completed = false;
                                      saveFormProgress();
                                    "
                                  />
                                </div>
                                <div v-else>
                                  {{ gun.gun_measurements[index - 1].weight }}
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div
                    v-if="gunsEqualizationCompleted && !updated_powder_output_measurements"
                    class="row"
                  >
                    <div class="col-lg-10">
                      <h5 class="">Powder Output Chart</h5>
                      <guns-equalization-chart />
                    </div>
                    <gun-throughput
                      title="Guns Equalization"
                      :gun-throughput="last_powder_throughput ? parseFloat(last_powder_throughput.toFixed(1)) : 0"
                      :line="line"
                      :powder-amount-parameters="powder_amount_parameters"
                      :is-compliant-with-target-throughput-per-gun="is_compliant_with_target_throughput_per_gun"
                      :diagnosis-values-per-gun="diagnosis_values_per_gun"
                      :min-powder-amount-setting="min_powder_amount_setting"
                      :max-powder-amount-setting="max_powder_amount_setting"
                    />
                  </div>
                  <div
                    v-if="!gunsEqualizationCompleted || updated_powder_output_measurements"
                    class="col-12 text-center mt-4 mb-4"
                  >
                    <button
                      type="button"
                      class="mt-4 mb-2 text-center btn"
                      :class="
                        isEmptyPowderOutputMeasurementsComputed
                          ? 'bg-gradient-secondary'
                          : 'bg-gradient-success'
                      "
                      style="width: 90%"
                      @click="calculateGunsEqualization()"
                    >
                      Calculate Powder Amount adjustments
                    </button>
                  </div>
                  <div
                    v-if="!updated_powder_output_measurements && gunsEqualizationCompleted"
                    class="col-12 text-end mt-4 mb-4"
                  >
                    <soft-button
                      type="button"
                      class="mb-0 ms-auto js-btn-next w-20"
                      style="width: 50%; min-width: 160px; max-width: 200px"
                      :disabled="!gunsEqualizationCompleted"
                      @click="
                        $router.push({
                          name: 'FineTuneLineDashboard',
                          params: { lineId: lineId },
                        })
                      "
                    >
                      Go Back &nbsp; &nbsp;
                    </soft-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { nextTick } from "vue";
import axios from "axios";
import eventBus from "@/views/applications/blueprint/utils/eventBus.js";
import setTooltip from "@/assets/js/tooltip.js";

import {
  autoFillInputColumn,
  generateMeasurementList,
  getTestPowderOutputMeasurements,
  gunNamesExist,
  numericPositiveOnly,
  isEmptyPowderOutputMeasurements,
  roundPowderAmountParameters,
} from "@/views/composables.js";
import GunsEqualizationChart from "../components/GunsEqualizationChart.vue";
import GunThroughput from "../components/GunThroughput.vue";
import SoftButton from "@/components/SoftButton.vue";

export default {
  name: "GunsEqualizationFinetune",
  components: {
    GunsEqualizationChart,
    GunThroughput,
    SoftButton,
  },
  props: {
    lineId: {
      type: String,
      default: "",
    },
    gunsEqualizationId: {
      type: String,
      default: "",
    },
  },
  data() {
    this.$i18n.locale = this.$store.state.user_data.language;

    return {
      powderoutput_measurements: [
        {
          empty_bag_weight: null,
          gun_measurements: [
            {
              setting: "",
              weight: "",
            },
            {
              setting: "",
              weight: "",
            },
          ],
        },
      ],
      line: {
        name: "",
        gun_names: [],
        total_pistols: [0],
      },
      min_powder_amount_setting: null,
      max_powder_amount_setting: null,
      time_interval: 60,
      updated_powder_output_measurements: false,
      is_calculation_completed: false,
      last_powder_throughput: null,
      powder_amount_parameters: [],
      is_compliant_with_target_throughput_per_gun: [],
      diagnosis_values_per_gun: [],
      // Line Layout image variables
      canvas_width: null,
      canvas_height: null,
      ctx_line_layout: null,
      line_layout_image: [],
      guns_equalization_history: [],
    };
  },
  computed: {
    noGunsEqualizationId() {
      return this.gunsEqualizationId == "" || this.gunsEqualizationId == null;
    },
    isEmptyPowderOutputMeasurementsComputed() {
      return this.isEmptyPowderOutputMeasurements(this.powderoutput_measurements);
    },
    gunsEqualizationCompleted() {
      let guns_equalization_completed =
        !this.isEmptyPowderOutputMeasurementsComputed &&
        this.powder_throughput_per_gun != null &&
        this.is_calculation_completed == true;

      return guns_equalization_completed;
    },
    maxPairs() {
      let maxPairs = 0;
      this.powderoutput_measurements.forEach(gun => {
        if (gun.gun_measurements.length > maxPairs) {
          maxPairs = gun.gun_measurements.length;
        }
      });
      return maxPairs;
    },
    editablePowderOutputMeasurements() {
      return this.$route.query.fromHistory !== "true";
    },
  },
  mounted() {
    this.$store.state.isAbsolute = true;
    this.getData();
    nextTick(() => {
      setTooltip();
    });
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
  },
  methods: {
    autoFillInputColumn,
    generateMeasurementList,
    getTestPowderOutputMeasurements,
    gunNamesExist,
    numericPositiveOnly,
    roundPowderAmountParameters,
    isEmptyPowderOutputMeasurements,
    async getData() {
      this.$store.state.isLoading = true;
      await this.getFineTuneLine();
      this.getCompletedGunsEqualizationsHistory();

      if (this.noGunsEqualizationId) {
        const initial_data = await this.getInitialData();
        this.setInitialData(initial_data);
        await this.createGunsEqualizationFineTune();
      } else {
        await this.getGunsEqualizationData();
      }

      this.showLineLayout();

      // // FOR TESTING PURPOSES
      // if (this.isEmptyPowderOutputMeasurementsComputed) {
      //   console.log("populating powder output measurements");
      //   this.powderoutput_measurements = this.getTestPowderOutputMeasurements();
      // }

      if (!this.isEmptyPowderOutputMeasurementsComputed && this.gunsEqualizationCompleted) {
        await this.computeGunsEqPowderAmountParams();
        await this.showGunsEqualizationGraph();
        this.updated_powder_output_measurements = false;
      }
      this.$store.state.isLoading = false;
    },
    async createGunsEqualizationFineTune() {
      const dataForm = {
        line: this.lineId,
        powder_throughput_per_gun: this.powder_throughput_per_gun,
        powder_output_measurements: this.powderoutput_measurements,
        max_powder_amount_setting: this.max_powder_amount_setting,
        min_powder_amount_setting: this.min_powder_amount_setting,
        time_interval: this.time_interval,
        is_calculation_completed: false,
      };
      const response = await axios.post(`/api/v1/finetune/gunsequalization/`, dataForm);

      const gunsEqualizationId = response.data.id;

      this.$router.replace({
        name: "GunsEqualizationFineTune",
        params: { lineId: this.lineId, gunsEqualizationId: gunsEqualizationId },
      });
    },
    async getInitialData() {
      try {
        const response = await axios.get(`api/v1/finetune/gunsequalization/getinitialdata/line/${this.lineId}/`);
        return response.data;
      } catch (error) {
        console.error(error);
        if (error.response && (error.response.status === 404 || error.response.status === 500)) {
          this.$swal({
            title: "Initial data could not be retrieved.",
            text: error.response.data.error,
            icon: "error",
            confirmButtonText: "OK",
          });
          this.saveFormProgress();
        }
      }
    },
    setInitialData(initial_data) {
      this.powder_throughput_per_gun = initial_data.last_powder_throughput;
      this.last_powder_throughput = JSON.parse(JSON.stringify(initial_data.last_powder_throughput));
      this.min_powder_amount_setting = initial_data.min_powder_amount_setting;
      this.max_powder_amount_setting = initial_data.max_powder_amount_setting;
      this.time_interval = initial_data.time_interval;
      this.powderoutput_measurements = this.clearWeightMeasurements(initial_data.powder_output_measurements);
    },
    async calculateGunsEqualization() {
      if (this.isEmptyPowderOutputMeasurementsComputed) {
        this.$swal({
          title: "Empty Measurements",
          text: "Please fill all the Powder Output Measurement fields",
          icon: "error",
          confirmButtonText: "OK",
        });
        return;
      }

      this.is_calculation_completed = true;
      this.updated_powder_output_measurements = false;

      await this.computeGunsEqPowderAmountParams();
      await this.showGunsEqualizationGraph();

      await this.saveFormProgress();
      this.successSwal();
    },
    clearWeightMeasurements(powderoutput_measurements) {
      const powderoutput_measurements_cleared_weights = powderoutput_measurements.map(gun => ({
        empty_bag_weight: null,
        gun_measurements: gun.gun_measurements.map(pair => ({
          setting: pair.setting,
          weight: "",
        })),
      }));

      return powderoutput_measurements_cleared_weights;
    },
    async getGunsEqualizationChartDataset() {
      if (this.isEmptyPowderOutputMeasurementsComputed) {
        return;
      }

      let body = {
        min_powder_amount_setting: this.min_powder_amount_setting,
        max_powder_amount_setting: this.max_powder_amount_setting,
        time_interval: this.time_interval,
        powderoutput_measurements: this.powderoutput_measurements,
        cumulative_powderoutput_measurements: true,
      };

      const response = await axios.post("/api/v1/blueprint/gunsequalizationchart/", body);
      this.$store.state.gunsEqualizationChart = response.data.powderoutput_measurements;

      if (gunNamesExist(this.line.gun_names)) {
        this.$store.state.gunsEqualizationChart.datasets.forEach((dataset, index) => {
          dataset.label = "Gun " + this.line.gun_names[index];
        });
      }
    },
    async computeGunsEqPowderAmountParams() {
      if (this.isEmptyPowderOutputMeasurementsComputed) {
        return;
      }

      try {
        let body = {
          time_interval: this.time_interval,
          measures_list: this.generateMeasurementList(this.powderoutput_measurements),
          powder_per_minute: this.powder_throughput_per_gun,
          cumulative_powderoutput_measurements: true,
          min_powder_amount_setting: this.min_powder_amount_setting,
          max_powder_amount_setting: this.max_powder_amount_setting,
        };

        let response = await axios.post("/api/v1/fp/computepowderamountsettingsfromthroughput/", body);
        this.powder_amount_parameters = response.data.powder_amount_params;
        this.is_compliant_with_target_throughput_per_gun = response.data.is_compliant_with_target_throughput_per_gun;
        this.diagnosis_values_per_gun = response.data.diagnosis_values_per_gun;
        this.powder_amount_parameters = this.roundPowderAmountParameters(this.powder_amount_parameters);
      } catch (error) {
        console.error(error);
      }
    },
    async getFineTuneLine() {
      try {
        const line_response = await axios.get("api/v1/finetune/line/" + this.lineId + "/");

        line_response.data.pistols_max_movement_range = line_response.data.pistols_max_movement_range * 100;

        this.line = line_response.data;
        this.$store.state.isLoading = false;
      } catch (error) {
        console.error(error);
      }
    },
    async getGunsEqualizationData() {
      if (this.noGunsEqualizationId) {
        return;
      }

      try {
        const response = await axios.get(`api/v1/finetune/gunsequalization/${this.gunsEqualizationId}/`);

        if (response.data.powder_output_measurements !== null) {
          this.powderoutput_measurements = response.data.powder_output_measurements;
        }

        if (response.data.min_powder_amount_setting !== null) {
          this.min_powder_amount_setting = response.data.min_powder_amount_setting;
        }

        if (response.data.max_powder_amount_setting !== null) {
          this.max_powder_amount_setting = response.data.max_powder_amount_setting;
        }
        if (response.data.time_interval !== null) {
          this.time_interval = response.data.time_interval;
        }
        if (response.data.powder_throughput_per_gun !== null) {
          this.powder_throughput_per_gun = response.data.powder_throughput_per_gun;
          this.last_powder_throughput = JSON.parse(JSON.stringify(response.data.powder_throughput_per_gun));
        }
        this.is_calculation_completed = response.data.is_calculation_completed;
      } catch (error) {
        console.error(error);
      }
    },
    async saveFormProgress() {
      if (this.noGunsEqualizationId) {
        return;
      }

      try {
        const dataForm = {
          powder_output_measurements: this.powderoutput_measurements,
          is_calculation_completed: this.is_calculation_completed,
        };

        await axios.patch(`/api/v1/finetune/gunsequalization/` + this.gunsEqualizationId + `/`, dataForm);
      } catch (error) {
        console.error("Error saving form progress:", error);
      }
    },
    async successSwal() {
      try {
        await this.$swal({
          title: "Gun Equalization success",
          text: "Powder amounts fine tune adjustment calculation successful",
          icon: "success",
          confirmButtonText: "OK",
        });
      } catch (error) {
        console.error(error);
      }
    },
    async showGunsEqualizationGraph() {
      await this.getGunsEqualizationChartDataset();

      eventBus.emit("draw-gunsequlization-chart");
    },
    async showLineLayout() {
      nextTick(() => {
        var lineLayoutCanvas = document.getElementById("lineLayoutCanvas");
        this.canvas_width = lineLayoutCanvas.width;
        this.canvas_height = lineLayoutCanvas.height;
        this.ctx_line_layout = lineLayoutCanvas.getContext("2d");

        this.generateLineLayoutImage().then(() => {
          this.fillLineLayoutCanvas();
        });
      });
    },
    async generateLineLayoutImage() {
      try {
        var body = {
          line: this.lineId,
          canvas_width: this.canvas_width,
          canvas_height: this.canvas_height,
        };

        var response = await axios.post("/api/v1/fp/generatelinelayoutimage/", body);
        this.line_layout_image = response.data["layout_image"];
      } catch (error) {
        console.error(error);
      }
    },
    fillLineLayoutCanvas() {
      let line_layout_imageData = new ImageData(
        Uint8ClampedArray.from(this.line_layout_image.values()),
        this.canvas_width,
        this.canvas_height,
      );
      this.ctx_line_layout.putImageData(line_layout_imageData, 0, 0);
    },
    PowderAmountWeightCheck(target_value, gun_index) {
      if (
        this.powderoutput_measurements[gun_index].gun_measurements.some(
          pair => pair.weight !== "" && pair.weight <= this.powderoutput_measurements[gun_index].empty_bag_weight,
        )
      ) {
        this.$swal({
          title: "Invalid Powder Output Measurement",
          text: "The Powder Output measurement must be higher than the empty bag weight.",
          icon: "error",
          confirmButtonText: "OK",
        }).then(() => this.removePowderWeightInput(target_value, gun_index));
        return;
      } else if (
        this.powderoutput_measurements[gun_index].gun_measurements.some(
          (pair, index, array) => index > 0 && pair.weight !== "" && pair.weight <= array[index - 1].weight,
        )
      ) {
        this.$swal({
          title: "Invalid Powder Output Measurement",
          text: "Each Powder Output Measurement must be higher than the previous one.",
          icon: "error",
          confirmButtonText: "OK",
        }).then(() => this.removePowderWeightInput(target_value, gun_index));
        return;
      }
    },
    removePowderWeightInput(target_value, gun_index) {
      this.powderoutput_measurements[gun_index].gun_measurements.map(pair => {
        if (pair.weight == target_value) {
          pair.weight = "";
        }
      });
    },
    async getCompletedGunsEqualizationsHistory() {
      try {
        const response = await axios.get(`/api/v1/finetune/gunsequalizationscompletedbyline/${this.lineId}/?limit=15`);
        this.guns_equalization_history = response.data.results;
      } catch (error) {
        console.error("Error fetching Guns Equalization data:", error);
      }
    },
    async routeToGunsEqualizationHistoryItem(guns_equalization_id) {
      this.$router.push({
        name: "GunsEqualizationFineTune",
        params: {
          lineId: this.lineId,
          gunsEqualizationId: guns_equalization_id,
        },
        query: { fromHistory: true },
      });
      await this.getData();
      nextTick(() => {
        setTooltip();
      });
    },
  },
};
</script>

<style scoped>
.table-sm th,
.table-sm td {
  padding: 0.3rem;
}

.container-fluid {
  padding-top: 20px;
}

.previous-guns-equalization-row {
  background: #f5f5f5;
  cursor: pointer;
  border-radius: 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  transition:
    box-shadow 0.2s,
    background 0.2s;
  height: 50px;
  display: flex;
  align-items: center;
}

.previous-guns-equalization-row:hover {
  background: #dedede;
  color: #000000;
  box-shadow: 0 4px 16px rgba(51, 51, 51, 0.18);
}
</style>
